<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 6 6"
    fill="none"
    role="presentation"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      d="M4.952.29a.33.33 0 0 0-.648 0l-.08.394a.33.33 0 0 1-.258.26l-.394.078a.33.33 0 0 0 0 .649l.394.078a.33.33 0 0 1 .26.26l.078.394a.33.33 0 0 0 .648 0l.079-.394a.33.33 0 0 1 .26-.26l.393-.078a.33.33 0 0 0 0-.65L5.29.944a.33.33 0 0 1-.259-.26L4.952.29ZM1.967 1.571a.33.33 0 0 0-.628 0l-.225.678a.33.33 0 0 1-.21.21l-.678.226a.33.33 0 0 0 0 .627l.678.226a.33.33 0 0 1 .21.21l.225.677a.33.33 0 0 0 .628 0l.225-.678a.33.33 0 0 1 .21-.209l.678-.226a.33.33 0 0 0 0-.627l-.678-.226a.33.33 0 0 1-.21-.21l-.225-.678ZM4.28 4.218a.33.33 0 0 0-.628 0l-.06.182a.33.33 0 0 1-.21.209l-.182.06a.33.33 0 0 0 0 .628l.182.06a.33.33 0 0 1 .21.21l.06.182a.33.33 0 0 0 .628 0l.06-.182a.33.33 0 0 1 .21-.21l.181-.06a.33.33 0 0 0 0-.628l-.182-.06a.33.33 0 0 1-.209-.21l-.06-.181Z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: [Number, String],
      default: 6
    }
  }
}
</script>
